// SDN OFAC addresses
export const BLOCKED_ADDRESSES: string[] = []
